import { render, staticRenderFns } from "./approves.vue?vue&type=template&id=193ae32a&scoped=true"
import script from "./approves.vue?vue&type=script&lang=js"
export * from "./approves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ae32a",
  null
  
)

export default component.exports